import { useState, useEffect } from 'react';

interface IWindowSize {
  width?: number;
  height?: number;
  isMobile: boolean;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState<IWindowSize>({
    width: undefined,
    height: undefined,
    isMobile: false,
  });
  useEffect(() => {
    function handleResize() {
      const isMobile = (window.innerWidth <= 690);
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile,
      });
    }
    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

export default useWindowSize;
